/* tslint:disable */
/* eslint-disable */
/**
 * Web MMB BFF API
 * Version of Backend for Frontend API (mid-layer between FE and MMB API) designed for web frontend purposes.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SegmentAdditionalInfoGroupOriginalValuesFromJSON, SegmentAdditionalInfoGroupOriginalValuesToJSON, } from './SegmentAdditionalInfoGroupOriginalValues';
/**
 * @export
 */
export const SegmentAdditionalInfoGroupItemIconEnum = {
    Info: 'info',
    Train: 'train',
    Airplane: 'airplane',
    Bus: 'bus',
    Seat: 'seat',
    Wifi: 'wifi',
    PowerPlug: 'power_plug',
    Entertainment: 'entertainment',
    Ticket: 'ticket',
    Terminal: 'terminal',
    BoardingGate: 'boarding_gate'
};
/**
 * Check if a given object implements the SegmentAdditionalInfoGroupItem interface.
 */
export function instanceOfSegmentAdditionalInfoGroupItem(value) {
    if (!('icon' in value) || value['icon'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('value' in value) || value['value'] === undefined)
        return false;
    return true;
}
export function SegmentAdditionalInfoGroupItemFromJSON(json) {
    return SegmentAdditionalInfoGroupItemFromJSONTyped(json, false);
}
export function SegmentAdditionalInfoGroupItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'icon': json['icon'],
        'name': json['name'],
        'originalValues': json['original_values'] == null ? undefined : SegmentAdditionalInfoGroupOriginalValuesFromJSON(json['original_values']),
        'value': json['value'],
    };
}
export function SegmentAdditionalInfoGroupItemToJSON(json) {
    return SegmentAdditionalInfoGroupItemToJSONTyped(json, false);
}
export function SegmentAdditionalInfoGroupItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'icon': value['icon'],
        'name': value['name'],
        'original_values': SegmentAdditionalInfoGroupOriginalValuesToJSON(value['originalValues']),
        'value': value['value'],
    };
}
